<template>
	<div class="answer">
		<div class="main-con flex flex-column bg-primary">
			<!-- 内容区域左右切换 -->
			<div class="bg-white rounded-top-45">
				<!-- 图标类型 -->
				<div class="flex align-center justify-end p-3" style="padding-bottom: 15px">
					<!-- 四种图标 -->
					<div class="flex">
						<div class="flex align-center mr-3">
							<div class="icon rounded-circle success"></div>
							<span class="text-primary font-sm pl-1">正确</span>
						</div>
						<div class="flex align-center mr-3">
							<div class="icon rounded-circle error"></div>
							<span class="text-danger pl-1 font-sm">错误</span>
						</div>
						<div class="flex align-center mr-3">
							<div class="icon rounded-circle bg-light"></div>
							<span class="text-body pl-1 font-sm">未判</span>
						</div>
						<div class="flex align-center">
							<div class="icon rounded-circle half"></div>
							<span class="text-body pl-1 font-sm">半对半错</span>
						</div>
					</div>
				</div>
				<!-- 答题卡区域 -->
				<!-- 圆角 -->
				<!-- 答题结果【SUCCESS：正确；ERROR：错误；HALF：半对；NOTDO：未判】 -->
				<div class="answer-card  border-top">
					<div class="card-wrap flex flex-wrap">
						<div v-for="(item, index) in lists" :key="index" class="item-wrap">
							<div v-if="item.answerResult === 'SUCCESS'"
								class="aq-item success rounded-circle flex align-center justify-center" @click="toCartItem(index)">
								<span class="font-sm text-white">{{
									index + 1
								}}</span>
							</div>
							<div v-else-if="item.answerResult === 'HALF'"
								class="aq-item half rounded-circle flex align-center justify-center" @click="toCartItem(index)">
								<span class="font-sm text-white">{{
									index + 1
								}}</span>
							</div>
							<div v-else-if="item.answerResult === 'ERROR'"
								class="aq-item error rounded-circle flex align-center justify-center" @click="toCartItem(index)">
								<span class="font-sm text-white">{{
									index + 1
								}}</span>
							</div>
							<div v-else class="aq-item bg-light rounded-circle flex align-center justify-center"
								@click="toCartItem(index)">
								<span class="font-sm text-dark">{{
									index + 1
								}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 底部 -->
		<div class="position-fixed flex flex-column bottom-0 left-0 right-0">
			<!-- 按钮 -->
			<div class="flex px-4 mb-3">
				<div class="submit-btn border border-primary flex align-center justify-center main-bg-color rounded-circle mb-3"
					@click="checkParsing">
					<span class="font text-white">查看解析</span>
				</div>
				<div class="submit-btn border border-primary flex align-center justify-center main-bg-color rounded-circle"
					@click="toAgainHandle">
					<span class="font text-white">再做一遍</span>
				</div>
			</div>
			<!-- 占位符 -->
			<div class="flex justify-between px-5 footer-bar bg-white align-center"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Answer",
		data() {
			return {
				projectName: "23",
				projectId: "23",
				courseId: "23", // 课程Id
				courseName: "课程23",
				classId: "2", // 课次Id
				className: "课次2",
				imgBaseUrl: "https://stb.ttxinli.com/stb",
				lists: [],
				baseUrl: "",
				mapKey: "1", // 唯一key
			};
		},
		props: {
			question: {
				type: Object,
				default: {},
			},
		},
		created() {
			let {
				courseId,
				classId,
				courseName,
				className,
				projectId,
				projectName,
			} = this.question;
			console.log(this.question);
			this.courseId = courseId;
			this.classId = classId;
			this.projectId = projectId;
			this.projectName = projectName;
			this.courseName = courseName;
			this.className = className;
		},
		mounted() {
			//
			this.getList();
		},
		methods: {
			// 结果-获取
			async getList() {
				let params = {
					courseId: this.courseId,
					classId: this.classId,
					courseName: this.courseName,
					className: this.className,
					type: 2,
				};
				let res = await this.$axios.$post(
					"/cgzd-learning/pc/questions/practiceList",
					params
				);
				console.log(res);
				this.lists = res.userAnswerList;
			},
			// 答题卡 跳转切换题
			toCartItem(params) {
				this.$emit("toCartItem", params);
			},
			checkParsing() {
				this.$emit("checkParsing");
			},
			// 在做一遍
			toAgainHandle() {
				this.$emit("toAgain");
			},
		},
	};
</script>

<style scoped>
	.flex {
		display: flex;
	}

	.flex-column {
		flex-flow: column nowrap;
	}

	.p-3 {
		padding: 30px;
	}

	.mr-3 {
		margin-right: 30px;
	}

	.main-con {
		position: relative;
		border-radius: 8px;
		margin-top: -23px;
		z-index: 10;
		background-color: #ffffff;
	}

	.align-center {
		align-items: center;
	}

	.justify-between {
		justify-content: space-between;
	}

	.answer {
		height: 794px;
		background-color: #ffffff;
	}

	.btn {
		height: 80px;
	}

	.icon {
		height: 14px;
		width: 14px;
		border-radius: 50%;
		margin-right: 3px;
		background-color: #f1f3f8;
	}

	.footer-bar {
		height: 60px;
	}

	.flex-wrap {
		flex-wrap: wrap;
	}

	.answer-card {
		width: 420px;
		height: 627px;
		margin: 0 auto;
		padding: 30px 0 0;
		border-bottom: 1px solid #f1f3f8;
	}

	.item-wrap {
		width: 40px;
		height: 40px;
		margin-left: 55px;
		margin-bottom: 30px;
	}

	.item-wrap:nth-child(5n + 1) {
		margin-left: 0;
	}

	.aq-item {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background: #f1f3f8;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.error {
		background-color: #f17070;
	}

	.success {
		background-color: #70f1d3;
	}

	.half {
		background-color: #f1b070;
	}

	.submit-btn {
		width: 200px;
		height: 42px;
		border-radius: 21px;
		font-size: 14px;
		font-weight: 500;
		background: #e13f37;
		color: #ffffff;
		cursor: pointer;
		justify-content: center;
		margin: 30px auto 15px;
	}

	.border-top {
		border-top: 1px solid #f1f3f8;
	}
</style>
